import { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";

const Registros = () => {
  const [opcionesApp, setOpcionesApp] = useState([]);
  const [appSelect, setAppSelect] = useState("");
  const [registros, setRegistros] = useState([]);
  const [titulos, setTitulos] = useState([]);
  const BASE_URL = useOutletContext();
  // Paginación
  const [paginaActual, setPaginaActual] = useState(1);
  const registrosPorPagina = 100;

  // Obtener lista de apps disponibles
  useEffect(() => {
    fetch(`${BASE_URL}/models.php`, {
      method: 'POST', // 👈 importante
      headers: {
        'Content-Type': 'application/json' // 👈 para que PHP lo lea como JSON
      },
      body: JSON.stringify({ page: 'consultarRegistros' })
    })
      .then(res => res.json())
      .then(data => setOpcionesApp(data))
      .catch(err => console.error("Error al cargar apps", err));
  }, [BASE_URL]);

  // Obtener registros cuando cambia appSelect
  useEffect(() => {
    if (appSelect) {
      fetch(`${BASE_URL}/models.php`, {
        method: 'POST', // 👈 importante
        headers: {
          'Content-Type': 'application/json' // 👈 para que PHP lo lea como JSON
        },
        body: JSON.stringify({ page: 'documentoRegistros',
          appNombre:appSelect
         })
      })
        .then(res => res.json())
        .then(data => {
          setRegistros(data);
          setPaginaActual(1); // reinicia a la primera página
          if (data.length > 0) {
            setTitulos(Object.keys(data[0]));
          } else {
            setTitulos([]);
          }
        })
        .catch(err => console.error("Error al cargar registros", err));
    }
  }, [appSelect, BASE_URL]);

  const handleAppChange = (e) => {
    setAppSelect(e.target.value);
  };

  // Calcular registros para la página actual
  const indiceInicio = (paginaActual - 1) * registrosPorPagina;
  const indiceFin = indiceInicio + registrosPorPagina;
  const registrosPaginados = registros.slice(indiceInicio, indiceFin);
  const totalPaginas = Math.ceil(registros.length / registrosPorPagina);

  return (
    <main>
      <br />
      <h1>Documento Agente</h1>
      <br />
      <label htmlFor="appNombre">Selecciona una App:</label>
      <select id="appNombre" value={appSelect} onChange={handleAppChange}>
        <option value="">--Selecciona una App--</option>
        {opcionesApp.map((app, i) => (
          <option key={i} value={app.Nombre}>{app.Nombre}</option>
        ))}
      </select>

      {registros.length > 0 ? (
        <center>
          <h2>Registros de {appSelect}</h2>

          {/* Tabla */}
          <table border="1">
            <thead>
              <tr>
                {titulos.map((titulo, i) => (
                  <th key={i}>{titulo}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {registrosPaginados.map((registro, i) => (
                <tr key={i}>
                  {titulos.map((titulo, j) => (
                    <td key={j}>{registro[titulo]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>

          {/* Controles de paginación */}
          <div style={{ marginTop: "20px" }}>
            <button
              onClick={() => setPaginaActual(p => Math.max(p - 1, 1))}
              disabled={paginaActual === 1}
            >
              Anterior
            </button>
            <span style={{ margin: "0 10px" }}>
              Página {paginaActual} de {totalPaginas}
            </span>
            <button
              onClick={() => setPaginaActual(p => Math.min(p + 1, totalPaginas))}
              disabled={paginaActual === totalPaginas}
            >
              Siguiente
            </button>
          </div>
        </center>
      ) : appSelect ? (
        <p>No hay registros disponibles.</p>
      ) : null}
    </main>
  );
};

export default Registros;
